import React, { useEffect, useRef, useState } from "react";
import SectionMagazineCategories from "components/Sections/SectionMagazineCategories"
import { useParams } from "react-router-dom"
import { Slide } from 'react-slideshow-image';
import horoskop from "../../../images/horoskop.jpg"
import 'react-slideshow-image/dist/styles.css'
import HeaderFilter from "components/Sections/HeaderFilter"

const PageHoroskop = () => {
  const [data,setData] = useState([])
  const initialized = useRef(false);


  const spanStyle = {
    padding: '20px',
    background: "none",
    color: 'white',
    fontSize:"50px"
  }
  
  const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    height: '250px'
  }

  const slideImages = [
    // {
    //   url: 'https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    //   caption: "Horoskop"
    // },
    // {
    //   url:"https://i.ibb.co/LttdKXB/pexels-sharefaith-491036-1202723.jpg",
    //   caption: "Horoskop"
    // },
    {
      url: horoskop,
      caption: "Horoskop"
    },
  ]; 

  return (
    <div className={`nc-PageArchiveAudio `}>
      {/* HEADER */}
      <div className="w-full px-2 xl:max-w-screen-2xl mx-auto">
        <div className="container" style={{marginTop:"37px", textAlign:"left"}}>
          <HeaderFilter heading="Horoskop"/>
        {/* <Slide>
         {slideImages.map((slideImage, index)=> (
            <div className="container" key={index}>
              <div style={{ ...divStyle, 'backgroundImage': `url(${slideImage.url})` }}>
              </div>
            </div>
          ))} 
        </Slide> */}
          {/* <div className="absolute inset-0 text-white flex flex-col items-center justify-center">
            <h2 style={{fontSize:"50px"}} className="inline-block align-middle ml-3">
              Horoskop
            </h2>
          </div> */}
        </div>
      </div>
      {/* ====================== END HEADER ====================== */}

      <div className="container lg:pb-28 space-y-16 lg:space-y-28">
        <div>
          {/* <div className="flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <div className="block my-4 border-b w-full border-neutral-300 dark:border-neutral-500 sm:hidden"></div>
          </div> */}
              <h2>Kwiecień 2025</h2>
            <div className="horoskop-container">
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Baran 21 marca do 19 kwietnia
                </h4>
                <p>
                Osoby spod znaku Barana będą w doskonałych humorach dzięki Słońcu, które przemierza ich
znak zodiaku. Pojawią się ambitne pomysły, a w środę i czwartek wyjaśnią się różne trudne
sprawy. W weekend idealny czas na relaks, ale rodzina też okaże się ważna. Ktoś starszy lub
słabszy może potrzebować wsparcia, warto zwrócić na to uwagę.
            </p>
            </div>
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Byk 20 kwietnia do 22 maja
                </h4>
                <p>
                Osoby spod znaku Byka nabiorą ochoty na imprezy i wyjazdy. W poniedziałek i wtorek
Księżyc w ich znaku sprzyja kupowaniu biletów na różne atrakcje, planowaniu randek i
podróży. W miłości wiosenne ożywienie. Warto się z kimś umówić, tylko bez pośpiechu.
Trzeba też trochę odpocząć i zadbać o urodę, aby nabrać jeszcze więcej energii.
            </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Bliźnięta 23 maja do 21 czerwca
                </h4>
                <p>
                Osoby spod znaku Bliźniąt nie będą tracić czasu z nudnymi osobami, tylko zajmą się
własnymi sprawami. W pracy lepiej jednak osobiście pilnować ważnych spraw, zwłaszcza
finansowych. W środę i czwartek Księżyc w znaku Bliźniąt sprzyja zabawie i miłości. Weekend
spokojniejszy, warto odpocząć w towarzystwie ludzi, którzy nie narzekają.
            </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Rak 22 czerwca do 22 lipca
                </h4>
                <p>
                Osoby spod znaku Raka zaczną tydzień od ambitnych postanowień i będą zapracowane. Byle
do weekendu. W piątek i sobotę Księżyc w znaku Raka przyniesie więcej towarzyskich
atrakcji i warto będzie mieć na nie więcej czasu. Imprezy będą udane, możliwe inspirujące
znajomości.
              </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Lew 23 lipca do 23 sierpnia
                </h4>
                <p>
                Osoby spod znaku Lwa będą chciały odpocząć. Nadmiar bodźców może być irytujący, warto
zadbać o psychikę i zdrowie. Dopiero w niedzielę osoby spod znaku Lwa poczują przypływ sił,
bo Księżyc wkroczy do ich znaku. Pojawią się przyjaciele i będą mieli dobre pomysły na
spędzenie wolnego czasu. Warto iść na koncert czy do kina.
                </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Panna 24 sierpnia do 22 września
                </h4>
                <p>
                Osoby spod znaku Panny osiągną sukces, ale będą musiały czuwać nad przebiegiem
ważnych przedsięwzięć. Wenus pomoże o wszystkich zadbać, ale w weekend lepiej mieć czas
na rozwijanie własnych zainteresowań. Spotkanie dotyczące hobby czy rozwoju okaże się
bardzo udane. W piątek i sobotę Księżyc sprzyja też wyjazdom i randkom.
                </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Waga 23 września do 22 października
                </h4>
                <p>
                Osoby spod znaku Wagi odkryją, jak wykorzystać swoje talenty. Słońce sprzyja łagodzeniu
konfliktów, a w pracy pomoże też skutecznie negocjować. Jowisz także zachęca do rozwoju,
pomoże złapać trochę oddechu od stresów. W niedzielę możliwe sympatyczne towarzyskie
wydarzenia, których warto nie przegapić.
                </p>
            </div>    
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Skorpion 23 października do 21 listopada
                </h4>
                <p>
                Osoby spod znaku Skorpiona poczują, że muszą się wreszcie zająć własnym rozwojem.
Merkury w trygonie sprzyja sztuce, a porządki czy zakupy nie będą najważniejsze. Do wtorku
jednak lepiej unikać konfliktów i niepotrzebnych dyskusji, bo może być nerwowo. Od piątku
poprawa humoru i większe powodzenie, także w miłości.
                </p>
            </div>       
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Strzelec 22 listopada do 21 grudnia
                </h4>
                <p>
                Osoby spod znaku Strzelca będą miały sporo do załatwienia i tydzień może być niespokojny.
Merkury radzi mentalnie odciąć się od krytyków, bo z niektórymi osobami nie ma sensu
dyskutować. Od piątku zrobi się sympatyczniej, uda się odpocząć. Jowisz sprzyja odkrywaniu
niezwykłych miejsc z usługami, dobrych restauracji czy sklepów.
                </p>
            </div>        
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Koziorożec 22 grudnia do 19 stycznia
                </h4>
                <p>
                Osoby spod znaku Koziorożca będą troskliwe. Bezpieczeństwo i dobre samopoczucie bliskich
będzie dla nich ważne. Wenus pomoże zażegnać konflikty i pogodzić tych, którzy się kłócą.
Od piątku Księżyc przypomni, że trzeba zachować równowagę między życiem prywatnym a
obowiązkami. Uda się odpocząć, a wyjazdy będą bardzo udane.
                </p>
            </div>        
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Wodnik 20 stycznia do 18 lutego
                </h4>
                <p>
                Osoby spod znaku Wodnika poczują, że potrzebują więcej luzu i przyjemności. Milej będzie
wybrać się na spacer lub kawę z przyjaciółmi, zamiast zabierać się za kolejne zawodowe
wyzwania. W miłości ożywienie. W niedzielę Księżyc sprzyja randkom, a przed samotnymi
osobami spod znaku Wodnika pojawi się szansa na ważną znajomość.
            </p>
            </div>
            <div className="horoskop-content">
                <h4 style={{maxWidth:"400px"}} className="inline-block align-middle font-semibold ">
                Ryby 19 lutego do 20 marca
                </h4>
                <p>
                Osoby spod znaku Ryb wpadną na świetne pomysły, ale nie będą chciały się nimi dzielić ze
wszystkimi. Merkury w ich znaku pomoże znaleźć potrzebne informacje, sprzyja też
podróżom i zakupom. Od piątku Księżyc zachęca do zabawy i odpoczynku. W miłości
powodzenie. Wenus doda uroku osobom spod znaku Ryb, warto umawiać się na randki.
            </p>
            </div>                  
            </div>

          {/* <SectionMagazineCategories
            category={params.category}
            category_id={params.id}
            posts={data}
          /> */}

        </div>

        {/* <div className="relative py-16">
          <BackgroundSection />
        </div> */}
      </div>
    </div>
  );
};

export default PageHoroskop
